import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LocationComponent } from './location.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';

import { PipesModule } from '@shared-pipes/pipes.module';
import { TranslationModule } from '@app/app-translation.module';

import { FormInputModule, FormTextareaModule } from '@beego/ngx-form-components';
import { FormFullAddressModule } from '@internal/gui/structural-components/form-components/form-full-address-component/form-full-address.component.module';
import { ModalComponentModule } from '@shared-components/modal-component/modal.component.module';
import { MapModule } from '@beego/ngx-map';
import { DirectivesModule } from '@shared-directives/directives.module';

@NgModule({
	declarations: [LocationComponent],
	exports: [LocationComponent],
	imports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		IonicModule,
		TranslationModule,
		PipesModule,
		DirectivesModule,
		FormInputModule,
		FormTextareaModule,
		FormFullAddressModule,
		ModalComponentModule,
		MapModule,
	],
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class LocationComponentModule {}
